<template>
    <div class="home_page">
      <div v-if="!isShowSurveysModal">
        <div class="search_form">
          <form>
              <div class="icon"></div>
              <input type="search" placeholder="検索" @focus="handleInputFocus">
          </form>
        </div>

        <Bookmarks/>

        <Institutions/>
      </div>

      <Surveys v-else @hideSurveys="hideSurveys" />

      <ModalNotification v-if="notification.showNotification"
                         :content="notification.content"
                         :durationTime="notification.durationTime"
                         @cancel="closeNotification"
      />
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Search from '@/components/search'
import Bookmarks from '@/screens/home/bookmarks'
import Institutions from '@/screens/home/institutions'
import Surveys from '@/components/survey'
import ModalNotification from '@/components/modal-notification'
import Init from '@/components/init'
import { CAN_SHOW_SURVEY } from '@/config'

export default {
  name: 'home',
  data () {
    return {
      notification: {
        showNotification: false,
        content: '',
        durationTime: null
      }
    }
  },
  components: {
    Search,
    Institutions,
    Bookmarks,
    Surveys,
    ModalNotification,
    Init
  },
  computed: {
    ...mapGetters({
      surveys: 'surveys/surveys',
      isShowSurveysModal: 'surveys/isShowSurveysModal',
      notifications: 'masterData/notifications'
    }),
    canShowSurvey () {
      return CAN_SHOW_SURVEY.indexOf(this.$auth.user().authority) !== -1
    }
  },
  watch: {
    'notifications': async function (val) {
      if (!this.$auth.user().is_maker) {
        if (val.length) {
          let data = val
          const employee_code = this.$auth.user().employee_code
          let notifySeen = await localStorage.getItem('notify_seen')
          notifySeen = JSON.parse(notifySeen)

          if (notifySeen[employee_code]) {
            data = []
            const notifySeenEmployee = notifySeen[employee_code]
            val.map(v => {
              if (!notifySeenEmployee.includes(v.id)) {
                data.push(v)
              }
            })
          }

          if (data.length) {
            this.notification.content = data[0].content.replace(/\n/g, '<br />')
            this.notification.durationTime = parseInt(data[0].duration_time) * 1000
            this.notification.showNotification = true

            if (notifySeen[employee_code]) {
              notifySeen[employee_code].push(data[0].id)
            } else {
              notifySeen[employee_code] = [data[0].id]
            }

            await localStorage.setItem('notify_seen', JSON.stringify(notifySeen))
          }
        }
      }
    }
  },
  methods: {
    ...mapActions({
      setNavigatorLinks: 'navigator/setLinks',
      setNavigatorTitle: 'navigator/setTitle',
      getSurveys: 'surveys/getSurveys',
      setIsShowSurveysModal: 'surveys/setIsShowSurveysModal',
      getNumberSurveyNotComplete: 'masterData/getNumberSurveyNotComplete',
      getNGWords: 'masterData/getNGWords',
      getNumberUnReadApprove: 'masterData/getUnreadFineplayApprove',
      getNotifications: 'masterData/getNotifications'
    }),
    hideSurveys () {
      this.setIsShowSurveysModal(false)
    },
    handleInputFocus () {
      this.$router.push({name: 'institutions.search'})
    },
    closeNotification () {
      this.notification.showNotification = false
    }
  },
  async mounted () {
    const notifySeen = await localStorage.getItem('notify_seen')
    if (!notifySeen) await localStorage.setItem('notify_seen', JSON.stringify({}))

    if (this.$auth.user().is_maker && this.canShowSurvey) {
      this.setIsShowSurveysModal(true)
    }
    if (!this.$auth.user().is_maker) {
      await this.getNotifications()
    }

    this.setNavigatorLinks([])
    this.setNavigatorTitle('チャット')
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/home/index.vue